import { apiFetch, isWhitespaceString } from '@ami/react/core';
import { DealerUserFilter } from './dealerUserFilter';

export class DealerUser {
  userId = '';
  fullName = '';
  userName = '';
  password = '';
  email = '';
  phoneNumber = '';
  isDealerAdmin = false;
  authorizedDealerGroups = [];
  inviteUser = false;
}

export class DealerUserSearchResult {
  constructor(json) {
    this.id = json.userId;
    this.label = json.fullName;
    this.userId = json.userId;
    this.fullName = json.fullName;
    this.email = json.email;
    this.isRegistered = json.isRegistered;
    this.isRetired = json.isRetired;
    this.dealerGroups = json.dealerGroups;
  }

  isAuthorizedForDealerBranch(dealerGroupId, dealerBranchId) {
    const dealerGroupAuthorization = this.dealerGroups.find(
      (x) => x.dealerGroupId === dealerGroupId
    );
    if (!dealerGroupAuthorization) return false;
    const isDealerAdmin = dealerGroupAuthorization.isDealerAdmin;
    if (isDealerAdmin) return isDealerAdmin;
    return dealerGroupAuthorization.authorizedDealerBranches.some(
      (x) => x.dealerBranchId === dealerBranchId
    );
  }
}

export class Permissions {
  dealerBranch = [];
}

export class DealerBranchSetting {
  constructor(id, name) {
    this.dealerBranchId = id;
    this.name = name;
  }

  dealerBranchId = '';
  name = '';
  isAdministrator = false;
  permissions = ['ManageQuotes'];
}

const dealerUserUrl = 'dealer-users';

const getUser = (id) => {
  return apiFetch(`${dealerUserUrl}/${id}`);
};

const isUserAuthorizedForDealerBranch = (
  dealerGroupId,
  dealerBranchId,
  dealerGroups
) => {
  const dealerGroupAuthorization = dealerGroups.find(
    (x) => x.dealerGroupId === dealerGroupId
  );
  if (!dealerGroupAuthorization) return false;
  const isDealerAdmin = dealerGroupAuthorization.isDealerAdmin;
  if (isDealerAdmin) return isDealerAdmin;
  return dealerGroupAuthorization.dealerBranchAuthorization.some(
    (x) => x.dealerBranchId === dealerBranchId
  );
};

const dealerUserService = {
  search: async (filter = new DealerUserFilter(), page) => {
    if (isWhitespaceString(filter.search))
      filter.search = null;

    filter.setPaginationParameters(page);
    const result = await apiFetch(
      `${dealerUserUrl}?${filter.toQueryString()}`
    ).then((items) => items.map((x) => new DealerUserSearchResult(x)));

    return result;
  },
  downloadCsv: () => {
    return apiFetch(`${dealerUserUrl}/csv`);
  },
  getUser,
  createUser: (dealerUser, automaticSuccessNotification = true) => {
    return apiFetch(dealerUserUrl, 'POST', dealerUser, {
      automaticSuccessNotification: automaticSuccessNotification,
    });
  },
  updateUser: (dealerUser) => {
    return apiFetch(`${dealerUserUrl}/${dealerUser.userId}`, 'PUT', dealerUser);
  },
  updateUserForAppDealer: (dealerUser) => {
    return apiFetch(
      `${dealerUserUrl}/${dealerUser.userId}/for-app-dealer`,
      'PUT',
      dealerUser
    );
  },
  retireUser: (id) => {
    return apiFetch(`${dealerUserUrl}/${id}`, 'DELETE');
  },
  sendInvitationEmail: (id) => {
    return apiFetch(`${dealerUserUrl}/${id}/send-invitation`, 'POST');
  },
  changePassword: (dealerUser) => {
    let dto = { userId: dealerUser.userId, password: dealerUser.password };
    return apiFetch(`${dealerUserUrl}/${dto.userId}/password`, 'PUT', dto);
  },
  getAllPermissions: () => {
    return apiFetch(`${dealerUserUrl}/permissions`);
  },
  getAvailableEmailTemplateTypes: () => {
    return apiFetch(`${dealerUserUrl}/email-template-types`);
  },
  isUserAuthorizedForDealerBranch,
  authorizeUser: (dealerUserId, dealerBranchSetting) => {
    return apiFetch(
      `${dealerUserUrl}/${dealerUserId}/authorize`,
      'PUT',
      dealerBranchSetting
    );
  },
  getNotInvitedCount: () => {
    return apiFetch(`${dealerUserUrl}/not-invited-count`);
  },
  sendBulkInvitations: () => {
    return apiFetch(`${dealerUserUrl}/send-bulk-invitations`, 'POST', null);
  },
};
export { dealerUserService };
